import { createSelector } from '@ngrx/store';

import { BaseState, getBaseState } from '../reducers';
import { AppState } from './app.reducers';

export const getAppState = createSelector(
  getBaseState,
  (state: BaseState) => state.app
);

export const getCurrentLocale = createSelector(
  getAppState,
  (state: AppState) => state.currentLocale
);
export const getAvailableLanguages = createSelector(
  getAppState,
  (state: AppState) => state.availableLanguages
);
export const getDefaultLanguageCode = createSelector(
  getAppState,
  (state: AppState) => state.defaultLanguageCode
);
export const getCookiesPreference = createSelector(
  getAppState,
  (state: AppState) => state.cookiesPreference
);

export const getPerformanceWarningConfirmed = createSelector(
  getAppState,
  (state: AppState) => state.performanceWarningConfirmed
);
